/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78282 - Landing Bienvenida Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '../reducer/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;